var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(0 0.5)",
    fill: "#EDF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8V27.25H25.875V8H10.125ZM9.25 6.25H26.75C26.9821 6.25 27.2046 6.34219 27.3687 6.50628C27.5328 6.67038 27.625 6.89294 27.625 7.125V28.125C27.625 28.3571 27.5328 28.5796 27.3687 28.7437C27.2046 28.9078 26.9821 29 26.75 29H9.25C9.01794 29 8.79538 28.9078 8.63128 28.7437C8.46719 28.5796 8.375 28.3571 8.375 28.125V7.125C8.375 6.89294 8.46719 6.67038 8.63128 6.50628C8.79538 6.34219 9.01794 6.25 9.25 6.25Z",
    fill: "#092C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 27.25H30.25V29H5.75V27.25ZM12.75 9.75H16.25V12.375H12.75V9.75Z",
    fill: "#092C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27.25H21.5V25.5C21.5 24.5717 21.1313 23.6815 20.4749 23.0251C19.8185 22.3687 18.9283 22 18 22C17.0717 22 16.1815 22.3687 15.5251 23.0251C14.8687 23.6815 14.5 24.5717 14.5 25.5V27.25ZM18 20.25C19.3924 20.25 20.7277 20.8031 21.7123 21.7877C22.6969 22.7723 23.25 24.1076 23.25 25.5V29H12.75V25.5C12.75 24.1076 13.3031 22.7723 14.2877 21.7877C15.2723 20.8031 16.6076 20.25 18 20.25ZM12.75 15H16.25V17.625H12.75V15ZM19.75 9.75H23.25V12.375H19.75V9.75ZM19.75 15H23.25V17.625H19.75V15Z",
    fill: "#092C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSchoolIcon);
export default __webpack_public_path__ + "static/media/dashboard-school-icon.036dd00bd28000668064744a137b60d7.svg";
export { ForwardRef as ReactComponent };